<main class="govuk-width-container" *ngIf="showContent" id="main-content" tabindex="-1">
	<div>
		<div class="govuk-grid-row banner">
			<div class="govuk-grid-column-one-half banner-image">
				<img [src]="heroImage" alt="">
			</div>
			<div class="govuk-grid-column-one-half banner-content">
				<img src="assets/images/celebrate/celebrate-logo.png" class="banner-logo" alt="Celebrate in Lincolnshire">
				<h2>Discover your dream wedding destination in Lincolnshire</h2>
				<p>From stately homes and elegant country houses to grand halls and charming barns, find your ideal venue, to make your vision a reality.</p>
			</div>
		</div>		
	</div>
	
	<div class="govuk-grid-row">
		<div class="govuk-grid-column-full">
			<h2 class="mb-3">
				{{ startPageSubtitle }}
			</h2>

			<div [innerHTML]="startPageSubtitleBody"></div>

			<div class="button-container">
				<button class="btn btn-primary" (click)="startBooking()">
					Book your ceremony
				</button>
			</div>
		</div>
	</div>
</main>
